import { SaveWordsList } from "components/settings";
import { WidgetSettingFC } from "types/Setting";
import {
  convertWordsByParams,
  LINE_LIMIT_CHECK_IN,
  TOTAL_LINE_LIMIT_CHECK_IN,
  ValidationLimitProps,
  validationLimits,
} from "util/widgeTransformData";

interface WellbeingCheckData {}

interface WellbeingCheckProps {
  settingName: string;
}

export const WellbeingCheckWordsList: WidgetSettingFC<WellbeingCheckData, WellbeingCheckProps> = (
  props,
) => {
  const { settings, updateAnyWidgetSetting, info } = props;

  const handleConvertData = ({ value }: ValidationLimitProps) => {
    return convertWordsByParams({
      value,
      lineLimit: LINE_LIMIT_CHECK_IN,
      totalLineLimit: TOTAL_LINE_LIMIT_CHECK_IN,
    });
  };

  const handleValidation = ({ value }: ValidationLimitProps): boolean => {
    return validationLimits({
      value,
      totalLineLimit: TOTAL_LINE_LIMIT_CHECK_IN,
    });
  };

  return (
    <SaveWordsList
      settingName={info.settingName}
      updateSetting={updateAnyWidgetSetting!}
      value={settings.names}
      onConvertData={handleConvertData}
      onValidation={handleValidation}
    />
  );
};
